import React from 'react'
import { Main } from '../../layouts'
import { P, Link, Button, CombinedTitle } from '../../components'
import { colors } from '../../styles'

export const DefaultHomePage = () => (
  <Main
    helmet="Reuters Graphics. Portal"
    titleBlock={
      <>
        <br />
        <CombinedTitle first="Graphics" second="Portal" color={colors.portal} />
      </>
    }
  >
    <br />
    <P>
      There are no publishing groups on the portal yet. Go to the portal
      settings page to create one.
    </P>
    <br />
    <Link to="/settings/groups?tab=groups" invisible="true">
      <Button id="settings-page" color="primary" variant="contained">
        To the portal settings page
      </Button>
    </Link>
  </Main>
)
